module.exports = __webpack_public_path__ + "img/logo1.bc268cbc.png";